import React from 'react';
import { AttachedFile } from '../types';
import { AttachmentCloseIcon, AttachmentWarningIcon, DocumentIcon, SpinnerIcon } from './icons';

interface AttachmentPreviewProps {
  item: AttachedFile;
  onRemove: () => void;
}

const formatBytes = (bytes: number, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export const AttachmentPreview: React.FC<AttachmentPreviewProps> = ({ item, onRemove }) => {
  if (item.status === 'error') {
    return (
      <div className="w-[120px] h-[94px] p-1 flex flex-col justify-center items-center rounded-2xl border border-red-200 bg-red-50 shadow-custom-light relative">
        <AttachmentWarningIcon />
        <p className="text-red-700 text-center text-xs mt-1 px-2 leading-snug">{item.error}</p>
        <AttachmentCloseIcon onClick={onRemove} />
      </div>
    );
  }

  if (item.status === 'loading') {
    return (
      <div className="w-[120px] h-[94px] p-1 flex flex-col justify-center items-center rounded-2xl border border-primary-200 bg-primary-100 shadow-custom-light relative">
        <SpinnerIcon />
        <AttachmentCloseIcon onClick={onRemove} />
      </div>
    );
  }

  return (
    <div className="w-[120px] h-[94px] flex flex-col items-start rounded-lg border border-primary-200 shadow-custom-light relative">
      <div className="flex-1 self-stretch w-full rounded-t-lg bg-gray-200 flex items-center justify-center overflow-hidden">
        {item.previewUrl ? (
          <img src={item.previewUrl} alt={item.file.name} className="w-full h-full object-cover"/>
        ) : (
          <DocumentIcon />
        )}
      </div>
      <div className="p-1 self-stretch rounded-b-lg bg-primary-200">
        <p className="self-stretch text-grayscale-1100 font-grotesk text-[10px] font-medium leading-none truncate">{item.file.name}</p>
        <p className="self-stretch text-grayscale-1100 font-grotesk text-[10px] font-light leading-none">{formatBytes(item.file.size)}</p>
      </div>
      <AttachmentCloseIcon onClick={onRemove} />
    </div>
  );
};
